import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BrowsePageMetaService_GetMetaDataLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/browse_page/v1/meta/service.grpc.lazy';
import {useRecentFullUrl} from '@aboutyou/router';
import {ensure404Page} from '../../../shared-deprecated/metaUtils';
import {useEnsureRedirectData} from '../../../shared-deprecated/useEnsureRedirectData';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';

export const useGetMetaData = () => {
  const url = useRecentFullUrl();
  const targetGroup = useTargetGroupIdentifier();
  const ensureRedirectData = useEnsureRedirectData();

  return useGrpcRequest(
    BrowsePageMetaService_GetMetaDataLazy,
    {
      targetGroup,
      url,
    },
    {
      keepPreviousData: false,
      validateData: ensureRedirectData,
      validateError: ensure404Page,
    },
  );
};
